import { Routes } from '@angular/router';
import { English } from './components/email-en/email-en';
import { Spanish } from './components/email-sp/email-sp';
import { EnglishReminder } from './components/reminder-en/reminder-en';
import { SpanishReminder } from './components/reminder-sp/reminder-sp';

export const routes: Routes = [ 
  { path: '', pathMatch: 'full', redirectTo: 'email-en' },
  { path: 'email-en', component: English },
  { path: 'email-sp', component: Spanish },
  { path: 'reminder-en', component: EnglishReminder },
  { path: 'reminder-sp', component: SpanishReminder },
  { path: '**', redirectTo: 'email-en' },

];
